var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.853,
    height: 67.499,
    viewBox: "0 0 74.853 67.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_otro_lineal_color",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5122",
    transform: "translate(11.762 35.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5124",
    d: "M-297.49-114.016l17.962-6.175a4.242,4.242,0,0,1,5.184,1.763,4.233,4.233,0,0,1-2.08,6.04l-27.471,12.1a17.277,17.277,0,0,1-7.153,1.551,17.273,17.273,0,0,1-8.889-2.463l-7.689-4.614a15.837,15.837,0,0,0-6.732-1.736v-20.592h11.64a8.809,8.809,0,0,1,4.325,1.134l7.769,4.369a2.933,2.933,0,0,0,1.442.378h9.521a4.41,4.41,0,0,1,4.411,4.411,4.4,4.4,0,0,1-2.239,3.839",
    transform: "translate(334.359 128.146)",
    fill: "#ffcebf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5126",
    transform: "translate(23.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5128",
    d: "M-231,0c5.649,0,9.542,4.741,9.542,10.358,0,7.432-7.007,12.407-18.909,22.722-11.318-9.809-19.261-14.954-19.261-22.722,0-5.616,3.893-10.358,9.543-10.358,7.251,0,9.542,8.27,9.542,8.27S-238.25,0-231,0",
    transform: "translate(259.626)",
    fill: "#ee2b7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5130",
    transform: "translate(0 32.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5132",
    d: "M-94.9-23.726V-3.134A2.94,2.94,0,0,1-97.845-.2h-8.821V-26.667h8.821a2.94,2.94,0,0,1,2.94,2.94",
    transform: "translate(106.666 26.667)",
    fill: "#b1e0de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5134",
    transform: "translate(4.41 37.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5136",
    d: "M-11.863,0a1.471,1.471,0,0,1,1.47,1.47,1.471,1.471,0,0,1-1.47,1.47,1.471,1.471,0,0,1-1.47-1.47A1.471,1.471,0,0,1-11.863,0",
    transform: "translate(13.333 0)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5138",
    transform: "translate(0 32.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5140",
    d: "M-94.9-189.88a2.94,2.94,0,0,1-2.94,2.932h-8.821v-26.464h8.821a2.94,2.94,0,0,1,2.94,2.94v20.583Z",
    transform: "translate(106.666 213.413)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5142",
    transform: "translate(11.762 43.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5144",
    d: "M-296.648-52.3l.1-.035,17.962-6.175A4.242,4.242,0,0,1-273.4-56.75a4.233,4.233,0,0,1-2.08,6.04l-27.471,12.1a17.277,17.277,0,0,1-7.153,1.551,17.273,17.273,0,0,1-8.889-2.463l-7.689-4.613a15.835,15.835,0,0,0-6.732-1.736",
    transform: "translate(333.412 58.784)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5146",
    transform: "translate(11.762 35.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5148",
    d: "M0,0H11.64a8.809,8.809,0,0,1,4.325,1.134L23.734,5.5a2.934,2.934,0,0,0,1.442.378H34.7a4.411,4.411,0,0,1,0,8.821H19.751",
    transform: "translate(0)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5150",
    transform: "translate(23.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5152",
    d: "M0-57.073a9.407,9.407,0,0,1,9.078-7.073c7.251,0,9.542,8.27,9.542,8.27s2.291-8.27,9.543-8.27c5.649,0,9.542,4.741,9.542,10.358,0,7.432-7.007,12.407-18.909,22.722C11.627-37.281,5.812-41.623,2.512-45.945",
    transform: "translate(0 64.147)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5154",
    transform: "translate(21.906 11.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5156",
    d: "M-11.863,0a1.471,1.471,0,0,1,1.47,1.47,1.471,1.471,0,0,1-1.47,1.47,1.471,1.471,0,0,1-1.47-1.47A1.471,1.471,0,0,1-11.863,0",
    transform: "translate(13.333 0)",
    fill: "#3b0310"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtro);
export default __webpack_public_path__ + "static/media/otro.406624ab05a863a16d7a09fd0548b7ac.svg";
export { ForwardRef as ReactComponent };